export default __webpack_public_path__ + "static/media/Surge_Twitter1.da51ab63.png";